/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportGnl } from '../fn/dashboard-gnl/export-gnl';
import { ExportGnl$Params } from '../fn/dashboard-gnl/export-gnl';
import { GnlList } from '../models/gnl-list';
import { searchGnl$Any } from '../fn/dashboard-gnl/search-gnl-any';
import { SearchGnl$Any$Params } from '../fn/dashboard-gnl/search-gnl-any';
import { searchGnl$Json } from '../fn/dashboard-gnl/search-gnl-json';
import { SearchGnl$Json$Params } from '../fn/dashboard-gnl/search-gnl-json';


/**
 * All about the GNL dashboard
 */
@Injectable({ providedIn: 'root' })
export class DashboardGnlService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchGnl()` */
  static readonly SearchGnlPath = '/custom/dashboard/gnl/search';

  /**
   * Search GNL, with pagination.
   *
   * Search GNL, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchGnl$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchGnl$Json$Response(params?: SearchGnl$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GnlList>> {
    return searchGnl$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search GNL, with pagination.
   *
   * Search GNL, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchGnl$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchGnl$Json(params?: SearchGnl$Json$Params, context?: HttpContext): Observable<GnlList> {
    return this.searchGnl$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GnlList>): GnlList => r.body)
    );
  }

  /**
   * Search GNL, with pagination.
   *
   * Search GNL, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchGnl$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchGnl$Any$Response(params?: SearchGnl$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<GnlList>> {
    return searchGnl$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search GNL, with pagination.
   *
   * Search GNL, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchGnl$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchGnl$Any(params?: SearchGnl$Any$Params, context?: HttpContext): Observable<GnlList> {
    return this.searchGnl$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<GnlList>): GnlList => r.body)
    );
  }

  /** Path part for operation `exportGnl()` */
  static readonly ExportGnlPath = '/custom/dashboard/gnl/export';

  /**
   * Export GNL.
   *
   * Allows to export all the GNL as an XLSX File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportGnl()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportGnl$Response(params?: ExportGnl$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportGnl(this.http, this.rootUrl, params, context);
  }

  /**
   * Export GNL.
   *
   * Allows to export all the GNL as an XLSX File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportGnl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportGnl(params?: ExportGnl$Params, context?: HttpContext): Observable<Blob> {
    return this.exportGnl$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
